import { GenerateUUID, CreateImageElement } from "@/js/CommonFunc.js";

export default class FileKit {
  /** @param {File} file */
  constructor(file) {
    if (!(file instanceof File))
      throw new TypeError('FileKit: constructor expects a File');
    this.file = file;
    this.fileName = file.name;
    this.fileURL = URL.createObjectURL(file);
    this.extension = this.fileName.split('.').pop().toLowerCase();

    // const extension = file.name.slice(-4);
    // if( extension === ".png" ){
    //   this.imageURL = URL.createObjectURL(file);
    // }
  }

  // 画像のサイズを取得する
  async getImageSize()
  {
    const image = await CreateImageElement(this.fileURL);

    return {
      width: image.width,
      height: image.height,
    };
  }

  // ファイル名をリネームする
  rename( newName = "" ){
    if( newName ){
      this.fileName = newName + '.' + this.extension;
    }else{
      this.fileName = GenerateUUID() + '.' + this.extension;
    }
  }
}
export { FileKit }